// Script Related Enums
export enum ScriptPhase {
  FirstTime = 'firstTime',
  FewTimes = 'fewTimes',
  ManyTimes = 'manyTimes',
}

export enum ScriptKey {
  Booting = 'booting',
  ReadyToStart = 'readyToStart',
  Playing = 'playing',
  Writing = 'writing',
  Recording = 'recording',
  Evaluating = 'evaluating',
  AwaitingTap = 'awaitingTap',
  ReceivingDrawing = 'receivingDrawing',
  AssumeCorrect = 'assumeCorrect',
  MoveToNextStep = 'moveToNextStep',
  Helping = 'helping',
  CollectingFeedback = 'collectingFeedback',
  CollectingParentInfo = 'collectingParentInfo',
  Aborting = 'aborting',
  Correct = 'correct',
  Incorrect = 'incorrect',
  IncorrectLetter = 'incorrectLetter',
  IncorrectWord = 'incorrectWord',
  ReadyForNextStep = 'readyForNextStep',
  Retry = 'retry',
  FirstContinuous = 'firstContinuous',
  FirstQuickSound = 'firstQuickSound',
  Repeat = 'repeat',
  Continue = 'continue',
  Intro = 'intro',
  Quick = 'quick',
  Slow = 'slow',
  Begin = 'begin',
  Final = 'final',
  AlreadyIntro = 'alreadyIntro',
  Emphasize = 'emphasize',
  EmphasizeQuick = 'emphasizeQuick',
  UserMover = 'userMover',
  UserMoverRepeat = 'userMoverRepeat',
  StopSound = 'stopSound',
  ContinueNoContinuous = 'continueNoContinuous',
  Fast = 'fast',
  QuestionOnly = 'questionOnly',
  FullStory = 'fullStory',
  Continuous = 'continuous',
  FirstContinuousSound = 'firstContinuousSound',
  IntroNewFont = 'introNewFont',
  LastStartPrompt = 'lastStartPrompt',
  ReadTitle = 'readTitle',
  Later = 'later',
  ReviewIntro = 'reviewIntro',
  ReviewIntroNewFont = 'reviewIntroNewFont',
  IntroQu = 'introQu',
  IntroOE = 'introOE',
  IntroOh = 'introOh',
  IntroOu = 'introOu',
  IntroEa = 'introEa',
  IntroAi = 'introAi',
  EndsWithO = 'endsWithO',
  HasOEndsWithE = 'hasOEndsWithE',
  HasOEndsWithI = 'hasOEndsWithI',
  HasIEndsWithE = 'hasIEndsWithE',
  HasAEndsWithE = 'hasAEndsWithE',
  Short = 'short',
  AppReadsTitle = 'appReadsTitle',
  SecondReading = 'secondReading',
  IntroSecondPart = 'introSecondPart',
  IntroCapitalized = 'introCapitalized',
  IntroSecondPartCapitalized = 'introSecondPartCapitalized',
  NoHelp = 'noHelp',
  IntroBothKinds = 'introBothKinds',
  TwoSoundsIntro = 'twoSoundsIntro',
  TwoSoundsContinue = 'twoSoundsContinue',
  MultipleLetters = 'multipleLetters',
  StartMultipleLetters = 'startMultipleLetters',
  ReversedLetter = 'reversedLetter',
  LastLesson = 'lastLesson',
}

// Lesson Related Enums
export enum StepType {
  AppAsk = 'appAsk',
  AppAskToTap = 'appAskToTap',
  AppPronounce = 'appPronounce',
  UserPronounce = 'userPronounce',
  UserPronounceFast = 'userPronounceFast',
  AppSayFast = 'appSayFast',
  UserSayFast = 'userSayFast',
  BothSayFast = 'bothSayFast',
  AppSay = 'appSay',
  AppWrite = 'appWrite',
  UserWrite = 'userWrite',
  AppSoundOut = 'appSoundOut',
  UserSoundOut = 'userSoundOut',
  UserSayRhymeSound = 'userSayRhymeSound',
  UserSoundOutContinuous = 'userSoundOutContinuous',
  AppReadSentence = 'appReadSentence',
  UserReadSentence = 'userReadSentence',
  BothReadSentence = 'bothReadSentence',
  UserSayLetterName = 'userSayLetterName',
}

export enum TaskType {
  NewCritter = 'New Critter',
  SoundsIntroduction = 'Sounds Introduction',
  SayItFast = 'Say It Fast',
  SayTheSounds = 'Say The Sounds',
  SayTheSoundsReview = 'Say The Sounds Review',
  SoundsReview = 'Sounds Review',
  SayItFastReview = 'Say It Fast Review',
  Sounds = 'Sounds',
  ChildTouchesSounds = 'Child Touches Sounds',
  WordReading = 'Word Reading',
  Rhyming = 'Rhyming',
  FirstReading = 'First Reading',
  SecondReading = 'Second Reading',
  CritterReadsTheFastWay = 'Critter Reads The Fast Way',
  PictureComprehension = 'Picture Comprehension',
  ReadingTheFastWay = 'Reading The Fast Way',
  WordFinding = 'Word Finding',
  SoundsWriting = 'Sounds Writing',
  LessonComplete = 'Lesson Complete',
  CapitalLetters = 'Capital Letters',
}

export enum BallMover {
  User = 'user',
  App = 'app',
}
